import React from 'react';
import AuthInfo from '../../common/AuthInfo';
import ipcLogoSmall from '../../../images/ipc_logo_small.png';
import UserManual from '../../common/UserManual';

const AppHeaderRightContainer = () => (
  <div className="header-right-container">
    <UserManual />
    <AuthInfo />
    <img
      className="logo"
      alt="IPC logo"
      src={ipcLogoSmall}
    />
  </div>
);

export default AppHeaderRightContainer;
